module.exports = __webpack_public_path__ + "img/rafiki.db887e80.svg";